import { Injectable, OnInit } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { configObj } from '../configuration';
import { Subject } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Global } from '../global';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { Angulartics2 } from 'angulartics2';
import { OwlOptions } from 'ngx-owl-carousel-o';
import * as _ from "underscore";

@Injectable({
  providedIn: 'root'
})
export class CommonService implements OnInit {

  public customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: true,
    dots: false,
    autoHeight: true,
    autoWidth: true,
    startPosition: 0,
    navSpeed: 300,
    margin: 0,
    items: 1,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    pullDrag: true,
    responsive: {
      0: {
        items: 1.6,
        margin: 25,
      },
      580: {
        items: 1.6,
        margin: 35,
      }
    },
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    // private toastr: ToastrService,
    public global: Global,
    private ngxService: NgxUiLoaderService,
    public angulartics2: Angulartics2,
  ) { }

  ngOnInit(): void {
  }

  public benefitTheme:string = 'defaultTheme'
  public dashboardNoModifyData:any
  public userSelectedLanguage: Subject<string> = new Subject<string>()
  public userLogedIn: boolean = false;
  public loginMobileNumber: string | number;
  public carouselInfo: Array<object> = [];
  public showLimitDataSaveBtn: boolean = false
  public showManageDataSaveBtn: boolean = false
  public dashboardActualData: any = []
  public dashboardManageData
  public userInfo = {};
  public resendTimer:number = 600
  public resendInterval
  public benefitCaroDataEnablement
  // public redirectionData
  private getSessionId() {
    if (window.sessionStorage && sessionStorage && sessionStorage.getItem('sessionId')) {
      return this.generateDecRequest(sessionStorage.getItem('sessionId'));
    }
  }

  public startDragging(event: any, label) {
    this.carouselInfo.forEach(element => {
      // element["editCarolimitdisplay"] = false;
      // element["editLimitAttempt"] = false;
    });
  }

  public prepareHeaders() {
    let sessionId = this.getSessionId();
    if (sessionId) {
      var obj = {
        headers: new HttpHeaders({
          'sessionid': sessionId,
          'cache-control': 'no-cache'
        })
      };
      return obj;
    } else {
      this.router.navigate(['login']);
    }
  }

  // subscribe behaviour
  public trackUser(label: any, action: any, data): void {
    this.trackUserApi(label, action, data).subscribe(
      data => {
      },
      error => {
      }
    );
  }

  // generate unique key
  public generateRandomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  public logout() {
    return this.http.get(configObj.baseUrl + '/user/crd/crdlogout', this.prepareHeaders());
  }

  //encrypt data
  public generateEncRequest(strToEnc) {
    const key = CryptoJS?.enc.Utf8.parse(configObj.key);
    const randomIV = this.generateRandomString(16);
    const iv = CryptoJS?.enc.Utf8.parse(randomIV);
    const plainText: string = strToEnc?.toString();
    const encrypted = CryptoJS?.AES.encrypt(plainText, key, {
      keySize: 16,
      iv: iv,
      mode: CryptoJS?.mode.CBC,
      padding: CryptoJS?.pad.Pkcs7
    });
    return randomIV + encrypted.toString();
  }

  //decrypt data
  public generateDecRequest(strToEnc) {
    strToEnc = strToEnc ? strToEnc?.toString() : 'null';
    let data = decodeURIComponent(strToEnc);
    let iv = data?.slice(0, 16);
    let encryptedData = data?.substring(16, data?.length);
    // var CryptoJS = require('crypto-js');
    var Key = CryptoJS?.enc.Utf8?.parse(configObj?.key);
    var IV = CryptoJS?.enc.Utf8?.parse(iv);
    return CryptoJS?.AES?.decrypt(encryptedData, Key, {
      keySize: 16,
      iv: IV,
      mode: CryptoJS?.mode?.CBC,
      padding: CryptoJS?.pad?.Pkcs7
    }).toString(CryptoJS?.enc?.Utf8);
  }

  // public returnValidError(error) {
  //   if (error && error.error && error.error.cause) {
  //     if (error.status == 401 || error.status == 404) {
  //       this.redirecToLoginWithClearAll(error.error)
  //     } else {
  //       this.toastr.error('Something went wrong, please try again later!');
  //     }
  //   } else {
  //     this.toastr.error('Something went wrong, please try again later!');
  //   }
  // }

  // public redirecToLoginWithClearAll(error) {
  //   if (error && error.cause && (error.cause.toLowerCase().includes('user is not logged in') || error.cause.toLowerCase().includes('no session found'))) {
  //     sessionStorage.clear()
  //     this.toastr.error("User is not Logged in");
  //     this.router.navigate(['/login']);
  //     return false;
  //   } else {
  //     this.toastr.error("Something went wrong, please try again later!");
  //     return false;
  //   }
  // }

  //mask mobile number
  maskMobileNumber(number) {
    if (number) {
      var maskedValue: any;
      var orgVal = number.toString();
      var temp1 = orgVal.slice(0, 2)
      var temp2 = orgVal.slice(5, 7)
      var temp3 = orgVal.slice(9, 10)
      maskedValue = temp1 + "***" + temp2 + "**" + temp3
      return maskedValue
    }
  }

  //post otp
  postOtp(otp, id,consent?) {
    var url = configObj.baseUrl + "/user/crd/authentication"
    var requestBody = {
      "id": id,
      "otp": this.generateEncRequest(otp)
    }
    if(consent){
      requestBody['oblockConsent'] = consent
      return this.http.post(url, requestBody, this.prepareHeaders());
    }
    else{
      return this.http.post(url, requestBody);
    }
  }

  //request to get resend otp
  getResendOtp(id,consent?) {
    var url = configObj.baseUrl + "/user/crd/resend"
    var requestBody = {
      "id": id
    }
    if(consent)
    {
      return this.http.post(url, requestBody, this.prepareHeaders());
    }
    else{
      return this.http.post(url, requestBody);
    }
  }

  //check for session
  public checkSession() {
    return new Promise((resolve, reject) => {
      //Call API to check session validity
      var url = configObj.baseUrl + '/user/crd/sesdet'
      if (this.getSessionId()) {
        this.ngxService.start();
        this.http.get(url, this.prepareHeaders()).subscribe(
          data => {
            if( data['userInfo'] && data['userInfo']['mobileNumber']){
              this.loginMobileNumber = data['userInfo']['mobileNumber']
            }
            this.ngxService.stop();
            if (data && data['nextPage']?.toUpperCase() == 'USER_DASHBOARD') {
              this.userInfo['attemptId'] = data['attemptId']
              this.createDashboardData(data)
            }
            resolve(data);
            this.userLogedIn = true
          },
          error => {
            this.ngxService.stop();
            reject('error');
            this.logoutUser()
          }
        );
      }
      else {
        reject('error');
      }
    });
  }

  //get data from uuid
  getDataFromUUID(uuid,uniqueId?,isOblockLp?) {
    var url = configObj.baseUrl + '/user/crd/attempt'
    var requestBody = {
      "uuid": uuid,
      "operationType": "CheckUuidAttempt"
    }
    if(uniqueId){
      requestBody['rewardUniqueId'] = uniqueId
    }
    if(isOblockLp){
      requestBody["source"] = "OBLOCK_LP"
    }
    return this.http.post(url, requestBody);
  }

  //posting updated manage data 
  updateDashboardData(tokenid, data, source) {
    var url = configObj.baseUrl + "/user/crd/process/request/"
    var requestBody = {
      "source":source,
      "id": tokenid,
      "requestData": data
    }
    return this.http.post(url, requestBody, this.prepareHeaders());
  }

  //creating dashboard data with custom keys
  createDashboardData(data) {
    this.dashboardActualData = null
    this.dashboardManageData = null
    this.dashboardNoModifyData = null
    this.dashboardNoModifyData = JSON.parse(JSON.stringify(data['dashboardData']))
    this.dashboardActualData = JSON.parse(JSON.stringify(data['dashboardData']))
    this.dashboardManageData = JSON.parse(JSON.stringify(data));
    this.dashboardManageData['dashboardData'].forEach(element => {
      element['changedDomestic'] = element['domEnable']
      element['changedInternational'] = element['intEnable']
      element['changedLimit'] = element['currentLimit']
      // element['displayStatus'] = 1;
      element['tempLimit'] = element['currentLimit'];
    });
    this.loginMobileNumber = data['userInfo']['mobileNumber']
  }


  //get token id for posting data
  getApiToken(flag) {
    var url = configObj.baseUrl + '/user/crd/request'
    var requestBody = {
      "requestType": flag,
    }
    return this.http.post(url, requestBody, this.prepareHeaders());
  }

  //behaviour call
  public trackUserApi(label, action, data) {
    let sessionId = this.getSessionId();
    let ucode = null;
    var userUniqueCode = null;
    if (window.sessionStorage && sessionStorage.getItem('uuid')) {
      ucode = sessionStorage.getItem('uuid');
    }
    if (window.sessionStorage && sessionStorage && sessionStorage.getItem('userUniqueCode')) {
      userUniqueCode = sessionStorage.getItem('userUniqueCode')
    } else {
      if (window.sessionStorage && sessionStorage) {
        sessionStorage.setItem('userUniqueCode', this.generateRandomString(16));
      }
      userUniqueCode = sessionStorage.getItem('userUniqueCode')
    }
    var category
    if(this.router.url.length > 1){
      category = this.router.url.split("/")[1]
    }
    else{
      category = this.router.url
    }

    this.angulartics2.eventTrack.next({
				action: action + '_' + label,
				properties: {
          category:category
				},
		});
    let requestBody = {
      'pageName': this.router.url,
      'label': label,
      'action': action,
      "customerUniqueId": userUniqueCode,
      "sessionId": sessionId ? sessionId : null,
      "pageCategory": "Card Enablement",
      "uuid": ucode ? ucode : null
    };
    if (this.loginMobileNumber) {
      requestBody['mobileNumber'] = this.loginMobileNumber
    }
    var url = configObj.baseUrl + '/account/behaviour'
    if (sessionId) {
      return this.http.post(url, requestBody, this.prepareHeaders());
    } else {
      return this.http.post(url, requestBody);
    }
  }

  //show limit save button on dashbaord and card on carousel
  displayLimitSaveBtn(){
    if(this.dashboardManageData){
      for(var i = 0; i <  this.dashboardManageData['dashboardData'].length; i++ ){
        if( this.dashboardManageData['preSetup'] || ((this.dashboardManageData['dashboardData'][i]['changedLimit'] != this.dashboardManageData['dashboardData'][i]['currentLimit']) && !this.checkLimitCorrectValue())){
          this.showLimitDataSaveBtn = true;
          break;
        }
        else{
          this.showLimitDataSaveBtn = false
        }
      }
      this.checkTransactionChange();
    }
  }

  //show toggle manage save button on dashbaord and card on carousel
  displayManageSaveBtn(){
    if(this.dashboardManageData){
      for(var i = 0; i <  this.dashboardManageData['dashboardData'].length; i++ ){
        if((this.dashboardManageData['dashboardData'][i]['changedDomestic'] !== this.dashboardManageData['dashboardData'][i]['domEnable']) ||  (this.dashboardManageData['dashboardData'][i]['changedInternational'] !== this.dashboardManageData['dashboardData'][i]['intEnable']) ){
          this.showManageDataSaveBtn = true;
          break;
        }
        else{
          this.showManageDataSaveBtn = false
        }
    }
    this.checkTransactionChange();
    }
  }

  //if tempLimit is smaller than minLimit then hide manage save button 
  checkLimitCorrectValue() {
    for (let index = 0; index < this.dashboardManageData['dashboardData'].length; index++) {
      if (this.dashboardManageData['dashboardData'][index]['tempLimit'] < this.dashboardManageData['dashboardData'][index]['minLimit']) {
        return true
      }
    }
  }

  private checkTransactionChange() {
    let obj = _.findWhere(this.carouselInfo, { carouselCardType: 'OTP' });
    if (this.showManageDataSaveBtn || this.showLimitDataSaveBtn) {
      if (!obj) {
        this.carouselInfo.push({ carouselCardType: 'OTP' });
      }
    } else {
      if (obj && obj['carouselCardType']) {
        this.carouselInfo.pop();
      }
    }
  }

  //calling show button functions
  saveAllChange() {
    this.displayLimitSaveBtn();
    this.displayManageSaveBtn();
  }

  //post opt out consent
  postOptOut(accountId) {
    var url = configObj.baseUrl + '/user/opt/out/' + accountId
    var requestBody = {}
    return this.http.post(url, requestBody);
  }

  //post user manage data activity
  reportDashboardData(attemptId,keyRole,value){
    var url = configObj.baseUrl + "/user/crd/txn/activity"
    var requestBody = {
      "attemptId":attemptId,
      "eventName" :keyRole,
      "userValue" :value
    }
    return this.http.post(url,requestBody,this.prepareHeaders());
  }

  //get label and value for manage data activity
  postManageData(keyRole,value){
    // this.getApiToken("CARD_LIMIT_FLAG").subscribe(
    //   res => {
    //     if(res && res['id']){
    //       this.postManageDashboardData(res['id'],keyRole,value)
    //     }
    //   },
    //   err => {
    //   }
    // )
    this.postManageDashboardData(this.userInfo['attemptId'],keyRole,value)
  }

  //subscribe for user manage data activity
  postManageDashboardData(attemptId,keyRole,value){
    this.ngxService.start()
    this.trackUser('reportDashboardData','click',null)
    this.reportDashboardData(attemptId,keyRole,value).subscribe(
      res=>{
        this.ngxService.stop()
      },
      err=>{
        this.ngxService.stop()
      }
    )
  }

  //otp timer for 1min
  resendTimerSet(time){
    this.resendTimer = time
    clearInterval(this.resendInterval)
    this.resendInterval = setInterval(() => {
      if(this.resendTimer > 0){
        this.resendTimer = this.resendTimer - 1;
      }
    }, 1000);
  }

  //creating obj to post in api
  createDataWithUpdatedValues(){
    var item = {}
    this.dashboardActualData = this.dashboardNoModifyData
    this.dashboardManageData['dashboardData'].forEach((element, index) => {
      var tempStore = this.dashboardActualData
      tempStore[index]['domEnable'] = element['changedDomestic']
      tempStore[index]['intEnable'] = element['changedInternational']
      tempStore[index]['currentLimit'] = element['changedLimit']
      item[tempStore[index]['keyRole']] = tempStore[index]
    });
    this.dashboardActualData = item
  }

  logoutSession(id){
    var url = configObj.baseUrl +  "/user/crd/mobilelogout/" + id
    return this.http.get(url);
  }

  logoutUser(){
    this.ngxService.start()
    this.logout().subscribe(
      res => {
        this.ngxService.stop()
      },
      err => {
        this.ngxService.stop()
      }
    )
    this.resetData()
    setTimeout(() => {
      // this.router.navigate(['login'])
      this.loginRedirectionHandle()
    }, 10);
  }
  public redirectionPageTimer
  pageRedirectionHandling(res?,status?,source?){
    // this.redirectionData = res
    // this.redirectionData['status'] = status
    var delayTime:number = 0
    if(res?.['userInfo']){
      this.userInfo = res['userInfo']
    }
    if(res?.['welcomePageFlag'] && !res['userInfo']['corporateCard']){
      sessionStorage.setItem("onboardWelcome","onboardWelcome")
      if(res['rewardResponse'] && res['rewardResponse'].toLowerCase() == configObj.rewardFeatureV2TimesPrimeKey ){
        delayTime = 14000
      }
      else{
        delayTime = 7000
      }
      if(sessionStorage.getItem("utm_source") || (res['rewardResponse']) ){
        if(res['rewardResponse']){
          // this.dashboardManageData = JSON.parse(JSON.stringify(res));
          this.createDashboardData(res)
          this.userInfo['rewardResponse'] = res['rewardResponse']
          if(res['rewardResponse'].toLowerCase()  == configObj.rewardFeatureV2TimesPrimeKey){
            this.router.navigate(['/onboard'])
          }
          else{
            this.router.navigate(['/onboardV1'])
          }
        }
        else{
          this.router.navigate(['/onboardV1'])
        }
      }
      else{
        this.router.navigate(['/onboard'])
      }
    }
    this.redirectionPageTimer = setTimeout(() => {
      this.handleRedirections(res,status,source)
  }, delayTime);
  }

  resetLogin(){
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true,
    }).then(() => {
      window.location.reload();
    });
  }

  public postExperienceRatingDetail(rateData,starRateValue){
		var requestBody = {
			"attemptId": this.userInfo['attemptId'],
			"rating": starRateValue.toString(),
			"message": rateData.ratingMessage,
      "project":"ENEBL"
		}
		var url = configObj.feedbackBaseUrl + '/acquisition/feedback';
		return this.http.post(url, requestBody,this.prepareHeaders())
	}

  resetData(){
    var source
    if(sessionStorage.getItem("utm_source")){
      source = sessionStorage.getItem("utm_source")
    }
    sessionStorage.clear()
    if(source){
      sessionStorage.setItem("utm_source",source)
      sessionStorage.setItem("loginLoaded","loginLoaded")
    }
    this.userLogedIn = false
    this.dashboardManageData = undefined;
    this.dashboardActualData = undefined
    this.benefitCaroDataEnablement = null
    this.loginMobileNumber = null
    this.showLimitDataSaveBtn = false
    this.showManageDataSaveBtn = false
    this.userInfo = {}
    this.global.successScreenRef = {}
    this.benefitTheme = 'defaultTheme'
    this.isEcomEnableValue = true
    clearTimeout(this.redirectionPageTimer)
  }
  
  setBenefitTheme(cardType){
    if(!this.userInfo?.['rewardResponse'] || (this.userInfo?.['rewardResponse'] && (this.userInfo?.['rewardResponse']['allOffersExpired'] || (this.userInfo?.['rewardResponse']['expireHeadline'] && !this.userInfo?.['rewardResponse']['heading']))) || (this.userInfo?.['rewardResponse'] && this.userInfo?.['rewardResponse'].toLowerCase() != configObj.rewardFeatureV2TimesPrimeKey )){
      if(cardType.toLowerCase().includes('nexxt')){
        this.benefitTheme = 'nexxtTheme'
      }
      else if(cardType.toLowerCase().includes('pinnacle')){
        this.benefitTheme = 'pinnacleTheme'
      }
      else if(cardType.toLowerCase().includes('indulge')){
        this.benefitTheme = 'indulgeTheme'
      }
      else if(cardType.toLowerCase().includes('club vistara explorer')){
        this.benefitTheme = 'vistaraTheme'
      }
      else if(cardType.toLowerCase().includes('eazydiner')){
        this.benefitTheme = 'eazydinerTheme'
      }
      else if(cardType.toLowerCase().includes('platinum aura edge') ){
        this.benefitTheme = 'platinumTheme'
      }
      else if(cardType.toLowerCase().includes('legend')){
        this.benefitTheme = 'legendTheme'
      }
      else{
        this.benefitTheme = 'defaultTheme'
      }
    }
    else{
      this.benefitTheme = 'defaultTheme'
    }
  }

  loginRedirectionHandle(source?){
    if(sessionStorage.getItem("utm_source")){
      this.router.navigateByUrl(sessionStorage.getItem("utm_source"))
    }
    else{
      if(source){
         this.resetLogin()
      }else{
        this.router.navigate(['login'])
      }
    }
  }
  public isEcomEnableValue:boolean = true

  isEcomEnable(){
    if(this.dashboardManageData && this.dashboardManageData['dashboardData']){
      for (let index = 0; index < this.dashboardManageData['dashboardData'].length-1; index++) {
        if(this.dashboardManageData['dashboardData'][index]['keyRole'] == "ecommData"){
          if(this.dashboardManageData['dashboardData'][index]['domEnable'] && this.dashboardManageData['dashboardData'][index]['intEnable']){
            this.isEcomEnableValue =  true
          }
          else{
            this.isEcomEnableValue =  false    
          }
          break;
        }
        else{
          this.isEcomEnableValue = true
        }
      }
    }
  }

  handleRedirections(res,status,source?){
    if (!res['pinSetFlag'] && res['nextPage']?.toUpperCase() == 'USER_DASHBOARD' && !sessionStorage.getItem("dashboardOpen")) {
      sessionStorage.setItem("createpin",'createpin')
      if(res['attemptId']){
        this.userInfo['attemptId'] = res['attemptId']
      }
      this.createDashboardData(res)
      this.router.navigate(['/createpin'])
    }
    else if (res['nextPage'] && res['nextPage']?.toUpperCase() == 'USER_DASHBOARD') {
      if(res['attemptId']){
        this.userInfo['attemptId'] = res['attemptId']
      }
      this.createDashboardData(res)
      this.router.navigate(['/dashboard'])
    }
    else if (res['nextPage'] && res['nextPage']?.toUpperCase() == 'GENERAL_BLOCKED_DASHBOARD') {
      sessionStorage.setItem("generalBlock",'generalBlock')
      this.router.navigate(['/generalBlock'])
    }
    else if (res['nextPage'] && res['nextPage']?.toUpperCase() == 'OBLOCK_CONSENT_VIA_OTP_SCREEN') {
      if(res['attemptId']){
        this.userInfo['id'] = res['attemptId']
      }
      this.global.cardBlockScreen = 1 
      if(status && status == 'login'){
        sessionStorage.setItem('oblockConsent','oblockConsent')
        this.router.navigate(['/cardblocked'])
      }
    }
    else if (res['nextPage']?.toUpperCase() == 'OBLOCK_DASHBOARD') {
      if(res['attemptId']){
        this.userInfo['id'] = res['attemptId']
      }
      this.global.cardBlockScreen = 3
      if(status && status == 'login'){
        sessionStorage.setItem('oblockConsent','oblockConsent')
        this.router.navigate(['/cardblocked'])
      }
    }
    else if (res['nextPage']?.toUpperCase() == 'OBLOCK_DASHBOARD_REPEAT') {
      sessionStorage.setItem("oBlock",'oBlock')
      this.router.navigate(['/oBlock'])
    }
    else{
      // this.router.navigate(['/login'])
      this.loginRedirectionHandle(source)
    }
  }

  

}

